// extracted by mini-css-extract-plugin
export default {"reviewsCount":"reviewsCount--mp-CA8yn"};